// extracted by mini-css-extract-plugin
module.exports = {"documents":"styles__documents___3JDN7","learn":"styles__learn___2sxgd","titleWrapper":"styles__titleWrapper___1icEr","section":"styles__section___CrIZP"};